import NominaService from "@/api/services/personal/empleado/NominaService"
import Vue from "vue"
import { getYear, getMonth, getDaysInMonth, format, subDays } from "date-fns"

const state = () => ({
    nominas: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "codigo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    NOMINAS: state => {
        return state.nominas
    },
    NOMINAS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_NOMINAS: (state, payload) => {
        state.nominas = payload
    },

    SET_NOMINAS_PAG: (state, payload) => {
        state.pagination = payload
    }
}

const actions = {
    LOAD_NOMINAS: async ({ commit, state }, { nominasOption, customFilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (nominasOption === "1") {
                const anyo_actual = getYear(new Date())
                const mes_anterior = getMonth(new Date()) - 1
                const fecha_inicio = format(new Date(anyo_actual, mes_anterior, 1), "yyyy-MM-dd")
                const fecha_fin = format(
                    new Date(anyo_actual, mes_anterior, getDaysInMonth(new Date(anyo_actual, mes_anterior))),
                    "yyyy-MM-dd"
                )
                customFilter = `rango_fecha=${fecha_inicio} hasta ${fecha_fin}`
            }

            if (nominasOption === "2") {
                customFilter = `rango_fecha=${format(subDays(new Date(), 30), "yyyy-MM-dd")} hasta ${format(
                    subDays(new Date(), 1),
                    "yyyy-MM-dd"
                )}`
            }

            if (nominasOption === "3") {
                customFilter = `rango_fecha=${format(subDays(new Date(), 15), "yyyy-MM-dd")} hasta ${format(
                    subDays(new Date(), 1),
                    "yyyy-MM-dd"
                )}`
            }

            if (nominasOption === "4") {
                customFilter = `rango_fecha=${format(subDays(new Date(), 1), "yyyy-MM-dd")} hasta ${format(
                    subDays(new Date(), 1),
                    "yyyy-MM-dd"
                )}`
            }

            let { data, status, headers } = await NominaService.get({ customFilter, ...pagination })
            if (status === 200) {
                commit("SET_NOMINAS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_NOMINAS: async ({ commit }) => {
        try {
            let { data, status } = await NominaService.getAll()
            if (status === 200) {
                commit("SET_NOMINAS", data)
                return null
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
